"use strict";
var logo = document.querySelector(".logo");
var promise1 = new Promise(function(resolve) {
    logo.addEventListener("click", function() {
        resolve("Promise was resolved!");
    });
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        reject(new Error("Promise was rejected!"));
    }, 3000);
});
function handleSuccess(message) {
    var div = document.createElement("div");
    div.className = "message";
    div.textContent = message;
    document.body.appendChild(div);
}
function handleError(error) {
    var div = document.createElement("div");
    div.className = "message error-message";
    div.textContent = error.message;
    document.body.appendChild(div);
}
promise1.then(handleSuccess).catch(handleError);
promise2.then(handleSuccess).catch(handleError);

//# sourceMappingURL=index.9f4c1de5.js.map
